import { useState, useRef } from "react";
import InputField from "../../../components/ui/form/InputField";
import Button from "../../../components/ui/utils/Button";
import apiRequest from "../../../utils/vendorManager/apiRequest"
import toast from "react-hot-toast";
import  { LoginImg,LogoMain } from "../../../utils/helper";
import { LOGIN_ROUTE } from "../../../routes/vendorManager/vendorRoutes";

const ForgotPassword = () => {
  const [step, setStep] = useState("enter_mobile");
  const [loading, setLoading] = useState(false);

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [newPass, setNewPass] = useState("");

  const otpRef0 = useRef(null);
  const otpRef1 = useRef(null);
  const otpRef2 = useRef(null);
  const otpRef3 = useRef(null);
  const otpRefs = [otpRef0, otpRef1, otpRef2, otpRef3];

  const handleSendOtp = async () => {
    if (!mobile) return toast.error("Enter mobile number");

    try {
      setLoading(true);
      await apiRequest.sendOtp({ body: { mobile } });

      toast.success("OTP sent!");
      setStep("enter_otp");
    } catch (e) {
      toast.error("Unable to send OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleOtpInput = (val, index) => {
    if (!/^\d?$/.test(val)) return;

    const arr = otp.padEnd(4, " ").split("");
    arr[index] = val;
    const newOtp = arr.join("").trim();
    setOtp(newOtp);

    if (val && index < 3) {
      otpRefs[index + 1].current?.focus();
    }
  };

  const handleVerifyOtp = () => {
    if (otp.length !== 4) return toast.error("Enter valid 4-digit OTP");
    setStep("new_password");
  };

  const handleReset = async () => {
    if (!newPass) return toast.error("Enter new password");
    if (otp.length !== 4) return toast.error("Invalid OTP");

    try {
      setLoading(true);

      await apiRequest.resetPassword({
        body: { mobile, otp, newPassword: newPass },
      });

      toast.success("Password updated! Please login.");

      window.location.href = LOGIN_ROUTE;
    } catch (e) {
      toast.error("Unable to reset password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-gradient-to-br from-emerald-50 via-blue-50 to-green-100">
      
      <div className="hidden lg:block relative">
        <img
          src={LoginImg}
          className="w-full h-full object-cover"
          alt="Reset"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center flex-col justify-center">
          <img className="h-[100px] rounded-full border-red-500 shadow" src={LogoMain} alt="logo" />
          <h1 className="text-white text-4xl font-bold">Reset Password</h1>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <div className="bg-white rounded-3xl shadow-xl p-8 w-full max-w-md space-y-6">

          {step === "enter_mobile" && (
            <>
              <h2 className="text-xl font-bold">Forgot Password?</h2>
              <InputField
                label="Registered Mobile"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
              <Button onClick={handleSendOtp} isLoading={loading}>
                Send OTP
              </Button>
            </>
          )}

          {step === "enter_otp" && (
            <>
              <h2 className="text-xl font-bold">Enter OTP</h2>
              <div className="flex gap-3 justify-center">
                {otpRefs.map((ref, i) => (
                  <input
                    key={i}
                    ref={ref}
                    maxLength={1}
                    className="w-12 h-12 text-center border text-xl rounded-xl outline-none focus:ring-2"
                    onChange={(e) => handleOtpInput(e.target.value, i)}
                  />
                ))}
              </div>
              <Button onClick={handleVerifyOtp}>Verify OTP</Button>
            </>
          )}

          {step === "new_password" && (
            <>
              <h2 className="text-xl font-bold">New Password</h2>
              <InputField
                label="New Password"
                type="password"
                value={newPass}
                onChange={(e) => setNewPass(e.target.value)}
              />
              <Button onClick={handleReset} isLoading={loading}>
                Reset Password
              </Button>
            </>
          )}

        </div>
      </div>

    </div>
  );
};

export default ForgotPassword;
